import createTextComponent from './createTextComponent';
import styles from './H4.module.css';

export default createTextComponent(styles.h4, 'h4');
